import {Injectable} from "@angular/core";
import {User, UserAgent} from "src/app/infrastructure/moovement-api/models/user";
import {Device} from "@capacitor/device";
import {environment} from "src/app/environments/environment";
import {appVersion, verifier} from "src/app/app-info";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {AuthenticationApiClient} from "src/app/infrastructure/moovement-api/web-api/authentication.api-client";
import {TokenWrapper} from "src/app/domain/domain-models";
import {UserService} from "src/app/domain/user/user.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private authenticationApiClient: AuthenticationApiClient,
    private dataStorageService: DataStorageService,
    private userService: UserService
  ) {}

  async createUserAgent(token: string): Promise<UserAgent> {
    const device = await Device.getInfo()
    const deviceId = await Device.getId()
    const platform = environment.platform == 'web' ? 'other' : device.platform;
    const osVersion = device.osVersion
    return {
      id: deviceId.identifier + '-expirable',
      type: platform.toLocaleUpperCase(),
      notificationId: token,
      platform: platform,
      osVersion: osVersion,
      appVersion: environment.appName + ' ' + appVersion,
      topic: environment.topic,
      locale: "en_locale"
    }
  }

  async authenticateUser(uid: string, password: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.authenticationApiClient.signIn(uid, password)
        .subscribe({
          next: async (user) => {
            const authToken = btoa(`${uid}:${password}`);

            await this.dataStorageService.addKeyValuePair<TokenWrapper>('authToken', {token: authToken});
            await this.userService.init(user);

            resolve();
          },
          error: error => reject(error)
        });
    });
  }

  async extendSession(token: string) {
    const userAgent = await this.createUserAgent(token);
    await this.dataStorageService.addKeyValuePair('userAgent', userAgent);

    const user = await this.dataStorageService.getValueByKey<User>('user');
    if (!user) return;

    this.authenticationApiClient.extendSession({
      userId: user.id!,
      verifier: verifier,
      userAgent: userAgent
    }).subscribe();
  }
}
